import { DOCUMENT, NgIf } from '@angular/common';
import { Component, inject, Input, OnInit, Renderer2, RendererFactory2, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { environment } from '@environments/environment';
import { ReviewsFeature } from '@models/reviews-feature';

@Component({
  selector: 'app-shopper-approved',
  styleUrls: ['./shopper-approved.component.scss'],
  templateUrl: './shopper-approved.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, CardComponent],
})
export class ShopperApprovedComponent implements OnInit {
  @Input() public reviewsFeature: ReviewsFeature;
  public loading: boolean = true;

  private document = inject<Document>(DOCUMENT);
  private rendererFactory = inject(RendererFactory2);
  private renderer: Renderer2;

  public constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public ngOnInit(): void {
    this.loadShopperApprovedScript();
  }

  /**
   * Set the Shopper Approved configuration variable and load the script from the external url.
   */
  private loadShopperApprovedScript(): void {
    if (!this.reviewsFeature) {
      return;
    }

    const shopperApprovedSettings = environment.shopperApproved;

    (window as any).sa_values = {
      ...shopperApprovedSettings,
      orderid: this.reviewsFeature.orderId,
      name: this.reviewsFeature.name,
      email: this.reviewsFeature.email,
    };

    const date = new Date();
    const scriptSrc = `//www.shopperapproved.com/thankyou/inline/${
      shopperApprovedSettings.site
    }.js?d=${date.getTime()}`;
    const script = this.loadScript(scriptSrc);
    script.onload = () => {
      this.loading = false;
    };
  }

  /**
   * Append a script to the document body.
   *
   * @param src the URL of an external script file
   *
   * @return { any } The element created
   */
  private loadScript(src: string): any {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(this.document.body, script);

    return script;
  }
}
